import type { FaireProductEntity } from "../../entity_types/product";

export const p_tkfbhjfcwx: FaireProductEntity = {
  token: "p_tkfbhjfcwx",
  type: "product",
  name: "Aloe & Protein Moisturizing Shampoo in BULK",
  brandToken: "b_enclnl0j",
  brandName: "Heliotrope",
  imageUrl:
    "https://cdn.faire.com/fastly/18f62cedc97844ee8d385114398fdc3793731b07baddce31280cd13b98ae1139.jpeg",
  galleryImageUrls: [],
  priceDollars: 64,
  description:
    'SOON to arrive in a 5-gallon CARBOY (comes with spigot).\n\nFeed your hair a light and healthy “protein shake.” Filled with hair-strengthening ingredients and moisturizers, this sulfate-free shampoo provides a pure clean. With the help of gentle botanicals, remove build-up without compromising the soft, silky feel of refreshed and quenched hair. Use daily, or whenever you want to give your locks a lift.&nbsp;\nfilled with hair-strengthening ingredients and moisturizers. ONE GALLON JUG OR 5-GAL CARBOY.\n\n* sulfate-free\n* gentle botanicals\n* removes build-up\n* no fragrance added\n\nBay Area folks: Now available in glass jugs! You may be able to return your jug as part of our Closed Loop Pilot Program.\n\nDon’t forget to buy a pump!\n\nNOTE: PLEASE IGNORE THE "RETAIL PRICE" THAT FAIRE INSISTS ON - FOR BULK PRODUCTS, THERE IS NO MSRP.',
  tags: [],
  msrpDollars: 199,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:14.804Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
